<script>
  /**
 *
 *
 *
 *
 *
 *
 *
 *
 */

  import OttoUp from './OttoUp.svelte';
  import EnergyEfficiency from './EnergyEfficiency.svelte';
  import BenefitBadge from './BenefitBadge.svelte';
  import Sustainability from './Sustainability.svelte';
  import { key as featureWidthAlignmentWithCinemas } from '../context/featureWidthAlignmentWithCinemas.js';
  import { getContext } from 'svelte';

  /*                */
  let {
    variation,
    pricing,
    showTopInfo = false,
    minimumOrderValueEligible = false,
    isMainVariation = false,
    featuresState = {},
    tableTracking
  } = $props();

  const showBottomBenefitBadge = variation.benefitId && variation.customerBenefitBadge;

  const showEnergyEfficiency =
    Array.isArray(variation.energyEfficiencyClasses) &&
    variation.energyEfficiencyClasses.length >= 1;

  const { widthAmount } = getContext(featureWidthAlignmentWithCinemas);
  const columnHorizontalPaddings = 32;
  const width = `${widthAmount - columnHorizontalPaddings}px`;
</script>

<div style:width class="reco_comparison__information-container">
  {#if showTopInfo && variation.topInfo}
    <div class="reco_comparison__top-info oc-copy-100">
      <strong>{variation.topInfo}</strong>
    </div>
  {/if}
  <div class="reco_comparison__original-price">
    {#if pricing.originalPricePrefix}
      <span class="reco_comparison__uvp-string oc-copy-100" role="tabpanel">
        {pricing.originalPricePrefix}
      </span>
    {/if}
    {#if pricing.originalPrice}
      <span
        class="reco_comparison__nowrap reco_comparison__price-line-through oc-copy-100"
        role="tabpanel">
        {pricing.originalPrice}
      </span>
    {/if}
  </div>
  {#if !variation.highlightText && !pricing.retailPricePrefix}
    <div class="reco_comparison__retail-price">
      <span
        class="reco_comparison__nowrap oc-headline-50"
        class:reco_comparison__price-red={pricing.originalPrice}
        role="tabpanel">{pricing.retailPrice}</span>
    </div>
  {/if}
  {#if variation.highlightText || pricing.retailPricePrefix}
    <div>
      {#if variation.highlightText}
        <span
          class="oc-headline-50"
          class:reco_comparison__price-red={pricing.originalPrice}
          role="tabpanel">{variation.highlightText}&nbsp;</span>
      {/if}

      {#if pricing.retailPricePrefix}
        <span
          class="reco_comparison__nowrap oc-headline-50"
          class:reco_comparison__price-red={pricing.originalPrice}
          role="tabpanel">{pricing.retailPricePrefix}&nbsp;</span>
      {/if}
      <span
        class="reco_comparison__nowrap oc-headline-50"
        class:reco_comparison__price-red={pricing.originalPrice}
        role="tabpanel">{pricing.retailPrice}</span>
    </div>
  {/if}

  {#if pricing.unitPrice}
    <div class="reco_comparison__price-per-unit oc-headline-10">
      <span role="tabpanel"> {pricing.unitPrice} </span>
    </div>
  {/if}
  {#if showBottomBenefitBadge}
    <BenefitBadge
      benefitDiscountValuePercent={variation.customerBenefitBadge}
      benefitId={variation.benefitId} />
  {/if}
  <OttoUp {minimumOrderValueEligible} />
  {#if showEnergyEfficiency}
    <EnergyEfficiency energyEfficiencyClasses={variation.energyEfficiencyClasses} />
  {/if}
  <Sustainability
    labels={variation.sustainabilities}
    variationId={variation.id}
    {isMainVariation}
    detailViewUrl={variation._links ? variation._links['o:detail-view']?.href : undefined}
    baseDetailViewUrl={variation._links
      ? variation._links['o:base-detail-view-url']?.href
      : undefined}
    variationDetailViewUrl={variation._links
      ? variation._links['o:variation-detail-view-url']?.href
      : undefined}
    isQueryUrl={variation.isQueryUrl}
    {featuresState}
    {tableTracking} />
</div>

<style lang="scss">
  :root {
    --padding_within_cell: 4px;
  }

  .reco_comparison__information-container {
    text-align: left;
    overflow: hidden;
    max-width: 100%;
    margin-top: var(--oc-semantic-spacing-100);
  }

  .reco_comparison__top-info {
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }

  .reco_comparison__nowrap {
    white-space: nowrap;
  }

  .reco_comparison__uvp-string {
    padding-right: var(--padding_within_cell);
  }

  .reco_comparison__retail-price {
    display: inline-block;
  }

  .reco_comparison__price-line-through {
    padding-right: var(--padding_within_cell);
    text-decoration: line-through;
  }

  .reco_comparison__price-red {
    color: $pl_color-red100;
  }

  .reco_comparison__price-per-unit {
    padding: 4px;
    color: $pl_color-grey400;
  }
</style>
